var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',{ref:"panelContent",staticClass:"background-overlay",class:{ show: _vm.value, overlay: _vm.useBackgroundOverlay },on:{"click":function($event){return _vm.$emit('input', false)}}},[_c('aside',{staticClass:"panel",class:_vm.side,on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }